(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["object-list"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const filterButtons = document.querySelectorAll('[data-letter]');
    const allItems = document.querySelectorAll('.resource-list__item');
    const pagination = document.querySelector('.pagination-wrapper');

    filterButtons.forEach((button) => {
      button.addEventListener('click', function () {
        const selectedLetter = this.dataset.letter.toLowerCase();

        filterButtons.forEach((btn) => btn.classList.remove('active'));
        this.classList.add('active');

        if (selectedLetter === 'all') {
          allItems.forEach((item) => {
            item.style.display = '';
          });

          if (pagination) {
            pagination.style.display = '';
          }

          const currentUrl = new URL(window.location.href);
          currentUrl.searchParams.delete('page');
          window.history.replaceState({}, '', currentUrl);

          return;
        }

        if (pagination) {
          pagination.style.display = 'none';
        }

        allItems.forEach((item) => {
          const title = item.dataset.title.trim().toLowerCase();

          const firstLetter = title.charAt(0);

          if (firstLetter === selectedLetter) {
            item.style.display = '';
          } else {
            item.style.display = 'none';
          }
        });
      });
    });
  });

  document.addEventListener('DOMContentLoaded', function () {
    const section = document.querySelector('.section-resource-list');
    const button = document.getElementById('backToTopBtn');

    function updateButton() {
      const rect = section.getBoundingClientRect();

      const sectionVisible = rect.top < window.innerHeight && rect.bottom > 0;

      const scrolledInsideSection = rect.top < -500;

      if (sectionVisible && scrolledInsideSection) {
        button.classList.add('visible');
      } else {
        button.classList.remove('visible');
      }
    }

    window.addEventListener('scroll', updateButton);
    updateButton();

    button.addEventListener('click', () => {
      const sectionMarcas = document.querySelector('.cms_section_marcas');

      if (sectionMarcas) {
        sectionMarcas.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
